module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/baby-sitting/child4-5d248d9d8376118ebf468eb37f01cef1.svg";